var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacedonateImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 915.695,
    height: 679.259,
    viewBox: "0, 0, 915.695, 679.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 5295.506,
    y1: 3089.515,
    x2: 5295.506,
    y2: 2481.315,
    gradientTransform: "matrix(1.018, 0.008, 0.007, 1.034, -156.367, -134.672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 5399.52,
    y1: 3154.178,
    x2: 5399.52,
    y2: 2708.738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 5738.98,
    y1: 3044.198,
    x2: 5738.98,
    y2: 3001.098,
    gradientTransform: "matrix(1, 0, 0, 1, -142.16, -110.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000000",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 5738.98,
    y1: 3121.038,
    x2: 5738.98,
    y2: 3077.928,
    gradientTransform: "matrix(1, 0, 0, 1, -142.16, -110.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000000",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 5591.59,
    y1: 2961.948,
    x2: 5591.59,
    y2: 2939.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000000",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 5800.1,
    y1: 3121.038,
    x2: 5800.1,
    y2: 3077.928,
    gradientTransform: "matrix(1, 0, 0, 1, -142.16, -110.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000000",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 5800.1,
    y1: 3044.198,
    x2: 5800.1,
    y2: 3001.098,
    gradientTransform: "matrix(1, 0, 0, 1, -142.16, -110.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000000",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 5663.19,
    y1: 2961.948,
    x2: 5663.19,
    y2: 2939.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000000",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-4850.195, -2474.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4869.543,2676.034 L5512.829,2476.165 C5527.333,2471.659 5542.743,2479.763 5547.25,2494.267 L5662.966,2866.705 C5667.472,2881.209 5659.368,2896.62 5644.864,2901.126 L5001.578,3100.995 C4987.074,3105.501 4971.663,3097.396 4967.157,3082.893 L4851.44,2710.455 C4846.934,2695.951 4855.039,2680.54 4869.543,2676.034 z",
    fill: "url(#Gradient_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4880.41,2677.504 L5509.504,2482.044 C5524.008,2477.538 5539.419,2485.642 5543.925,2500.146 L5654.968,2857.543 C5659.475,2872.047 5651.37,2887.458 5636.866,2891.964 L5007.771,3087.424 C4993.268,3091.93 4977.857,3083.825 4973.351,3069.322 L4862.307,2711.925 C4857.801,2697.421 4865.906,2682.01 4880.41,2677.504 z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4870.924,2739.684 L5552.542,2527.906 L5570.807,2586.694 L4889.189,2798.472 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5011.833,3002.545 L5185.016,2948.737 L5192.915,2974.158 L5019.731,3027.967 z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4998.5,2959.642 L5298.789,2866.342 L5306.688,2891.763 L5006.397,2985.063 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5060.66,2708.738 L5738.39,2708.738 C5753.578,2708.738 5765.89,2721.05 5765.89,2736.238 L5765.89,3126.678 C5765.89,3141.866 5753.578,3154.178 5738.39,3154.178 L5060.66,3154.178 C5045.472,3154.178 5033.16,3141.866 5033.16,3126.678 L5033.16,2736.238 C5033.16,2721.05 5045.472,2708.738 5060.66,2708.738 z",
    fill: "url(#Gradient_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5068.98,2713.278 L5727.74,2713.278 C5742.928,2713.278 5755.24,2725.59 5755.24,2740.778 L5755.24,3115.028 C5755.24,3130.216 5742.928,3142.528 5727.74,3142.528 L5068.98,3142.528 C5053.792,3142.528 5041.48,3130.216 5041.48,3115.028 L5041.48,2740.778 C5041.48,2725.59 5053.792,2713.278 5068.98,2713.278 z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5097.21,2780.658 L5118.01,2780.658 L5118.01,2839.718 L5097.21,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5123.83,2780.658 L5144.63,2780.658 L5144.63,2839.718 L5123.83,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5150.45,2780.658 L5171.25,2780.658 L5171.25,2839.718 L5150.45,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5197.04,2780.658 L5217.84,2780.658 L5217.84,2839.718 L5197.04,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5223.66,2780.658 L5244.46,2780.658 L5244.46,2839.718 L5223.66,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5250.28,2780.658 L5271.08,2780.658 L5271.08,2839.718 L5250.28,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5296.86,2780.658 L5317.66,2780.658 L5317.66,2839.718 L5296.86,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5323.49,2780.658 L5344.29,2780.658 L5344.29,2839.718 L5323.49,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5350.11,2780.658 L5370.91,2780.658 L5370.91,2839.718 L5350.11,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5396.69,2780.658 L5417.49,2780.658 L5417.49,2839.718 L5396.69,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5423.31,2780.658 L5444.11,2780.658 L5444.11,2839.718 L5423.31,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5449.93,2780.658 L5470.73,2780.658 L5470.73,2839.718 L5449.93,2839.718 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5097.21,3078.468 L5278.56,3078.468 L5278.56,3105.088 L5097.21,3105.088 z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5097.21,3033.548 L5411.66,3033.548 L5411.66,3060.168 L5097.21,3060.168 z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5614.29,2932.748 C5614.206,2930.332 5616.094,2928.305 5618.51,2928.218 L5624.77,2928.218 L5624.77,2890.738 L5568.88,2890.738 L5568.88,2933.838 L5614.28,2933.838 z",
    fill: "url(#Gradient_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5618.51,2973.198 C5616.094,2973.111 5614.206,2971.084 5614.29,2968.668 L5614.29,2967.538 L5568.89,2967.538 L5568.89,3010.638 L5624.77,3010.638 L5624.77,2973.198 z",
    fill: "url(#Gradient_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5568.89,2939.458 L5614.29,2939.458 L5614.29,2961.948 L5568.89,2961.948 z",
    fill: "url(#Gradient_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5640.48,2968.668 C5640.564,2971.084 5638.676,2973.111 5636.26,2973.198 L5630.04,2973.198 L5630.04,3010.678 L5685.92,3010.678 L5685.92,2967.538 L5640.52,2967.538 z",
    fill: "url(#Gradient_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5630.04,2890.738 L5630.04,2928.218 L5636.3,2928.218 C5638.716,2928.305 5640.604,2930.332 5640.52,2932.748 L5640.52,2933.838 L5685.92,2933.838 L5685.92,2890.738 z",
    fill: "url(#Gradient_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5640.48,2939.458 L5685.88,2939.458 L5685.88,2961.948 L5640.48,2961.948 z",
    fill: "url(#Gradient_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5614.48,2933.168 C5614.48,2930.959 5616.271,2929.168 5618.48,2929.168 L5624.48,2929.168 L5624.48,2895.878 L5571.18,2895.878 L5571.18,2934.138 L5614.49,2934.138 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5618.5,2969.078 C5616.291,2969.078 5614.5,2967.287 5614.5,2965.078 L5614.5,2964.078 L5571.17,2964.078 L5571.17,3002.348 L5624.47,3002.348 L5624.47,2969.078 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5571.17,2939.128 L5614.48,2939.128 L5614.48,2959.098 L5571.17,2959.098 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5639.46,2965.058 C5639.46,2967.267 5637.669,2969.058 5635.46,2969.058 L5629.46,2969.058 L5629.46,3002.338 L5682.76,3002.338 L5682.76,2964.088 L5639.46,2964.088 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5629.47,2895.878 L5629.47,2929.158 L5635.47,2929.158 C5637.679,2929.158 5639.47,2930.949 5639.47,2933.158 L5639.47,2934.158 L5682.78,2934.158 L5682.78,2895.878 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5639.47,2939.128 L5682.78,2939.128 L5682.78,2959.098 L5639.47,2959.098 z",
    fill: "#6C63FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacedonateImg4);
export default __webpack_public_path__ + "static/media/facedonate_img_4.05cac121.svg";
export { ForwardRef as ReactComponent };